import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify';
import { useMyContext } from '../../../../components/Provider/CommonProvider';
import Defaultloadinggif from '../../../../layout/Others/Defaultloadinggif';
import FormContainer from '../../../../components/CommonComponents/FormContainer';
import Wrapper from '../../../../components/CommonComponents/Wrapper';
import LeftWrapper from '../../../../components/CommonComponents/LeftWrapper';
import AdminBackNavigation from '../../../../components/CommonComponents/AdminBackNavigation';
import MessageLabel from '../../../../components/CommonComponents/MessageLabel';
import AdminCustomInput from '../../../../components/CommonComponents/AdminCustomInput';
import RightWrapper from '../../../../components/CommonComponents/RightWrapper';
import AdminCustomButton from '../../../../components/CommonComponents/AdminCustomButton';
import AdminSaveHeader from '../../../../components/CommonComponents/AdminSaveHeader';

const Social_Network_Settings = () => {

    const { fetchRequest } = useMyContext()

    const baseURL = process.env.REACT_APP_Baseurl
    const indexApi = `${baseURL}/admin/setting/index`
    const storeApi = `${baseURL}/admin/setting/store`

    const [formData, setFormData] = useState({});
    const [loading, setLoading] = useState(true)

    const handleInput = (e) => {
        const { type, value, name } = e.target;

        setFormData(prev => ({
            ...prev,
            [name]: value
        }))
    }

    const fetchData = async () => {
        try {
            setLoading(true)
            const response = await fetchRequest({
                method: 'GET',
                url: indexApi
            })

            if (response?.status) {
                toast.success(response?.message)
                setFormData(response?.setting)
                setLoading(false)
            }
        } catch (error) {
            toast.error(error?.message)
        } finally {
            setLoading(false)
        }
    }

    const handleStore = async () => {
        try {
            setLoading(true)
            const result = await fetchRequest({ method: 'POST', url: storeApi, data: formData })

            if (result?.status) {
                toast.success(result?.message)
                setLoading(false)
            }
        } catch (error) {
            toast.error(error?.message)
        } finally {
            setLoading(false)
        }
    }

    useEffect(() => {
        fetchData();
    }, [])

    if (loading) return <Defaultloadinggif className={"heightOnLoader"} />

    return (
        <>
            <AdminBackNavigation path="/settings" text="Back" />
            <AdminSaveHeader heading={'Social Networks Settings'} saveText={'Update'} saveMethod={handleStore} />
            <FormContainer>
                <LeftWrapper>
                    <Wrapper>
                        <MessageLabel text={"Facebook Page ID"} />
                        <AdminCustomInput name="facebook_page_id" value={formData?.facebook_page_id} onChange={handleInput} placeHolder={'Enter facebook ID'} />
                        <MessageLabel text={"Google Plus User ID"} />
                        <AdminCustomInput name="google_page_id" value={formData?.google_page_id} onChange={handleInput} placeHolder={'Enter facebook ID'} />
                        <MessageLabel text={"X User"} />
                        <AdminCustomInput name="twitter_page_id" value={formData?.twitter_page_id} onChange={handleInput} placeHolder={'Enter Twitter ID'} />
                        <MessageLabel text={"Instagram"} />
                        <AdminCustomInput name="instagram_page_id" value={formData?.instagram_page_id} onChange={handleInput} placeHolder={'Enter Instagram ID'} />
                        <MessageLabel text={"TikTok"} />
                        <AdminCustomInput name="tiktok_page_id" value={formData?.tiktok_page_id} onChange={handleInput} placeHolder={'Enter TikTok ID'} />
                    </Wrapper>
                </LeftWrapper>

                <RightWrapper>
                    <Wrapper>
                        <MessageLabel text={"Linkedin"} />
                        <AdminCustomInput name="linkedin_page_id" value={formData?.linkedin_page_id} onChange={handleInput} placeHolder={'Enter Linkedin ID'} />
                        <MessageLabel text={"Whatsapp"} />
                        <AdminCustomInput name="whatsapp_page_id" value={formData?.whatsapp_page_id} onChange={handleInput} placeHolder={'Enter Whatsapp ID'} />
                        <MessageLabel text={"Teams"} />
                        <AdminCustomInput name="skype_page_id" value={formData?.skype_page_id} onChange={handleInput} placeHolder={'Enter Teams ID'} />
                        <MessageLabel text={"YouTube Channel"} />
                        <AdminCustomInput name="youtube_page_id" value={formData?.youtube_page_id} onChange={handleInput} placeHolder={'Enter YouTube ID'} />
                        <MessageLabel text={"E-Mail"} />
                        <AdminCustomInput name="email_page_id" value={formData?.email_page_id} onChange={handleInput} placeHolder={'Enter Email ID'} />
                        <MessageLabel text={"Blue Sky"} />
                        <AdminCustomInput name="blue_sky_page_id" value={formData?.blue_sky_page_id} onChange={handleInput} placeHolder={'Enter Blue Sky ID'} />
                    </Wrapper>
                </RightWrapper>
                <AdminCustomButton className={'px-3 py-1 me-3 me-md-0 ms-md-auto d-flex'} saveText={'Update'} saveMethod={handleStore} />
            </FormContainer>
        </>
    )
}

export default Social_Network_Settings